import ScrollMagic from 'scrollmagic';

export const Timeline = (() => {
	'use strict';

	let $toggleShare;

	function init() {
		var sharableButton = $('.timeline--facts a');
		var shareLinks = $('.timeline--share');

		$toggleShare = $('#toggle-share');

		$toggleShare.click(function(){
			$(this).toggleClass('open');
		});

		copied();
		line();
		moveOrbs();
	}

	function line() {
		var timelines = document.querySelectorAll('.timeline--points');
		window.onscroll = function () {
			$(timelines).each(function () {
				/*Get parent ID*/
				var parentId = $(this).attr('id');
				var parId = ('#' + parentId);

				/*Get Line ID*/
				var lineId = $(this).children('.timeline--line').attr('id');
				var len = ('#' + lineId);

				/*Height of Parent*/
				var height = $(parId).height();
				$(len).css({
					"maxHeight": height
				});
				
				/*Get points*/
				var points = ('.timeline--point');
				var pointsHeight = $('.timeline--point').height();

				/*Check to see the DIV exhists to start*/
				if ($(len).length) {
					/*Calculates Windows & dimentions*/
					var top_of_element = $(parId).offset().top;
					var bottom_of_element = $(parId).offset().top + $(parId).outerHeight();
					
					/*The 150px offsets the cookie banner/bottom*/
					var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight() - 150;
					var bottom_of_screen_mobile = $(window).scrollTop() + $(window).innerHeight() - 250;
					var top_of_screen = $(window).scrollTop();
					
					/*Height fo the box*/
					let elementHeight = $(this).height();
					var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
					
					/*percent to scroll*/
					var percentage = ((bottom_of_screen - top_of_element) / elementHeight) * 100;
					

					/*Assigns inline height*/
					if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
						let line = document.getElementById(lineId);
						if(parseInt(percentage) > line.dataset.lastheight){
							line.dataset.lastheight = percentage;
							line.style.height = percentage + "%";	
						}
					}
					
					$(points).each(function() {
						/*Calculates Windows & dimentions*/
						var top_of_point = $(this).offset().top;
						var bottom_of_point = $(this).offset().top + $(this).outerHeight();
						
						if ( $(window).width() > 739) {      
							if ((bottom_of_screen > top_of_point) && (top_of_screen < bottom_of_point)){
								$(this).addClass('timeline--point--active');
							}
						} else {
							if ((bottom_of_screen_mobile > top_of_point) && (top_of_screen < bottom_of_point)){
								$(this).addClass('timeline--point--active');
							}
						}
					})
				}
			});
		};
	} /*End line();*/


	function copied() {
		let $temp = $("<input>");

		$('.share--link').on('click', function () {
			$("body").append($temp);
			$temp.val(url).select();
			document.execCommand("copy");
			$temp.remove();
			$("p.copied").text("Sharable Facts copied!").addClass('active');
			console.log('copied');
		})
	}

		
	 function moveOrbs() {
	 	var $orbs = $('.timeline--body .timeline--point .orb');

	 	function moveRandom(obj) {
	 		var topPos;
	 		var horPos;
	
	 		topPos = Math.floor(Math.random() * 90) + 1 + '%';
	 		horPos = Math.floor(Math.random() * 50) + 1 + '%';
	
	 		var leftObject = { 
	 			top: topPos,
	 			left: horPos
	 		  };
			
	 		var rightObject = { 
	 			top: topPos,
	 			right: horPos
	 		  };
	
	 		  if (obj.parent().hasClass('orbs__left')) {
	 			obj.css(rightObject);
	 		  }
			  
	 		  else {
	 			obj.css(leftObject);
	 		  }
	
	 		}
	
	 		$orbs.each(function() {
	 			moveRandom($(this));
	 			});	
	 }

return {
	init: init,
	name: 'timeline'
};
})();
